import React from "react";
import DialogModal from "../../../../../../components/Dialog";
import { dialog } from "../../../../../../nq-component";

function DialogDispatch({ index, onSubmitDispatch, onSubmit, onClose }) {
  // Auto-capture the dispatched date when the dialog opens
  const now = new Date();

  // Format as "March 24, 2026" for display
  const dispatchedDateDisplay = now.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  // ISO format (e.g. "2026-03-24T06:30:00.000Z") to pass to onSubmitDispatch
  const dispatchedDateTime = now.toISOString();

  return (
    <div className="rounded-3 overflow-hidden" style={{ minWidth: "380px" }}>
      {/* Header */}
      <div
        className="px-4 py-3 d-flex align-items-center gap-3"
        style={{
          background: "linear-gradient(135deg, #82c14a 0%, #6ba83a 100%)",
        }}
      >
        <div
          className="d-flex align-items-center justify-content-center rounded-circle"
          style={{
            width: "42px",
            height: "42px",
            background: "rgba(255,255,255,0.2)",
          }}
        >
          <i
            className="bi bi-truck text-white"
            style={{ fontSize: "1.2rem" }}
          />
        </div>
        <div>
          <h6
            className="mb-0 text-white fw-bold"
            style={{ fontSize: "0.95rem" }}
          >
            Dispatch Order
          </h6>
          <small
            style={{ color: "rgba(255,255,255,0.8)", fontSize: "0.75rem" }}
          >
            Confirm dispatch for this order
          </small>
        </div>
      </div>

      {/* Body */}
      <div className="px-4 py-4" style={{ background: "#fff" }}>
        <label
          className="d-flex align-items-center gap-2 mb-2 fw-semibold"
          style={{ fontSize: "0.85rem", color: "#374151" }}
        >
          <i className="bi bi-calendar-check" style={{ color: "#82c14a" }} />
          Dispatched Date
        </label>

        {/* Auto-filled dispatched date — set when user clicks the Dispatch button */}
        <div
          className="rounded-3 d-flex align-items-center gap-2"
          style={{
            border: "1px solid #e5e7eb",
            padding: "10px 14px",
            fontSize: "0.9rem",
            background: "#f9fafb",
            color: "#374151",
          }}
        >
          <i className="bi bi-clock" style={{ color: "#82c14a" }} />
          {dispatchedDateDisplay}
        </div>

        {/* Commented out: manual datetime input (replaced by auto-captured dispatch date)
        <input
          type="datetime-local"
          min={minDateTime}
          className="form-control rounded-3"
          style={{
            border: "1px solid #e5e7eb",
            padding: "10px 14px",
            fontSize: "0.9rem",
            transition: "border-color 0.2s ease, box-shadow 0.2s ease",
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#82c14a";
            e.target.style.boxShadow = "0 0 0 3px rgba(130, 193, 74, 0.15)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = "#e5e7eb";
            e.target.style.boxShadow = "none";
          }}
          onChange={(e) => {
            setEstimatedDateTime(e.target.value);
          }}
        />
        */}
      </div>

      {/* Footer */}
      <div
        className="px-4 py-3 d-flex justify-content-end gap-2"
        style={{ background: "#f9fafb", borderTop: "1px solid #f0f0f0" }}
      >
        <button
          className="btn btn-sm fw-semibold px-4 py-2 rounded-3"
          style={{
            background: "#f3f4f6",
            border: "1px solid #e5e7eb",
            color: "#374151",
            fontSize: "0.85rem",
          }}
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          className="btn btn-sm fw-semibold px-4 py-2 rounded-3 text-white"
          style={{
            background: "linear-gradient(135deg, #82c14a 0%, #6ba83a 100%)",
            border: "none",
            fontSize: "0.85rem",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(130,193,74,0.4)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "none";
          }}
          onClick={() => {
            dialog.close();

            setTimeout(() => {
              dialog.fire({
                html: (
                  <DialogModal
                    icon="bi bi-question-octagon-fill"
                    iconColor="#82c14a"
                    title="Confirm to Proceed"
                    message="Are you sure you want to continue this action?"
                    isCancelButton={true}
                    onSubmit={() => onSubmitDispatch(index, dispatchedDateTime)}
                    onClose={() => dialog.close()}
                  />
                ),
                footer: false,
              });
            }, 200);
          }}
        >
          <i className="bi bi-send me-1" /> Confirm
        </button>
      </div>
    </div>
  );
}

export default DialogDispatch;
